<template>
  <header id="HeaderLNB" class=" header flex bg-black justify-between">
    <div class="fl flex w-25 items-center h-100">
      <div class="mh2 mv1 logo-container mw-100">
        <img @click="goToHome" class="h-100 w-100 pointer db-l dn" src="~@/assets/logo-white.svg"
             alt="BeatHey Logo">
        <div class="dn-l pv1 isologo-container">
          <img @click="goToHome" class="w-100 h-100 pointer" src="~@/assets/isologo-white.svg" alt="BeatHey Logo">
        </div>
      </div>
    </div>
    <div class="fl flex mw-50 justify-center items-center ttu">
      <router-link v-if="false" class="link-primary ttu f5 flex items-center h-100 no-underline dib pa3 textColor"
                   :title="$t('app.360')"
                   :to="{name:'360'}">
        <font-awesome-icon class="iconColor mr0 mr2-l" icon="street-view"/>
        <span class="dn di-l">{{ $t("app.360") }}</span>
      </router-link>
    </div>
    <div class="fl flex min-w-25 justify-end items-center iconColor">
      <clip-loader :loading="loading" :color="color" :size="size" class="mh2"></clip-loader>
      <div v-if="!loading && !isLoggedIn" class="mr2 h-100 flex items-center">
        <div class="dn login">
          <div class="pr1 pointer ttu db customPosition">
            <router-link id="LNB" :to="{name: 'planes'}" title="Planes">{{ $t("landing.plans") }}</router-link>
          </div>
          <span class="ph2 f5 dib-ns dn customPosition"> | </span>
          <div @click="login" class="pr1 pointer ttu db btnLnb">
            <div class="customPosition">
              {{ $t("app.signin") }}
              <span class="ph2 ttl f5 dib-ns dn">{{ $t("app.or") }}</span>
              {{ $t("app.signup") }}
            </div>
          </div>
        </div>
        <div @click="login" class="pr1 pointer ttu btnLnbMobile">
            <div class="customPosition">
              {{ $t("app.signin") }}
            </div>
          </div>
        <div class="h-100">
          <div @click="loginDropdownTrigger" class="flex items-center h-100" v-on-click-outside="closeLoginDropdown">
            <font-awesome-icon class="iconColor pa2 pointer" icon="bars"/>
          </div>
          <transition name="fade">
            <div v-show="loginDropdown" class="dropdown-content db absolute w5-ns w4 flex flex-column">
              <a @click="setLanguage('es')" v-show="!isLocale('es')" class="pv2 ph3 f5 pointer w-100 ttu">{{ $t("footer.language.spanish") }}</a>
              <a @click="setLanguage('en')" v-show="!isLocale('en')" class="pv2 ph3 f5 pointer w-100 ttu">{{ $t("footer.language.english") }}</a>
              <a @click="setLanguage('pt')" v-show="!isLocale('pt')" class="pv2 ph3 f5 pointer w-100 ttu">{{ $t("footer.language.portuguese") }}</a>
              <!-- <a class="f5 h-100 no-underline pointer ttu ph3 pv2" href="https://shop.beathey.com" target="_blank">
                <span class="mr2">{{ $t('app.shop') }}</span>
                <font-awesome-icon icon="shopping-cart"/>
              </a> -->
              <router-link :to="{ name: 'help' }"
                           class="no-underline pv2 ph3 f5 pointer w-100 ttu iconColor">{{ $t("footer.help") }}
              </router-link>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="!loading && isLoggedIn" class="flex justify-end iconColor">
        <div class="relative iconColor" v-on-click-outside="closeDropdown">
          <div @click="dropdownTrigger">
            <user-info v-if="user" class="mw5 pointer iconColor"></user-info>
          </div>
          <transition name="fade">
            <div v-show="dropdown" class="dropdown-content db absolute w5 flex flex-column iconColor">
              <router-link :to="{ name: 'profile-info' }" @click.native="closeDropdown"
                           class="no-underline pv2 ph3 f5 pointer w-100">{{ $t("users.userMenu.myProfile") }}
              </router-link>
              <router-link :to="{ name: 'my-tracks' }" v-if="isProducer" @click.native="closeDropdown"
                           class="no-underline pv2 ph3 f5 pointer w-100">{{ $t("users.userMenu.myTracks") }}
              </router-link>
              <router-link :to="{ name: 'my-playlists' }" @click.native="closeDropdown"
                           class="no-underline pv2 ph3 f5 pointer w-100">{{ $t("users.userMenu.myPlaylists") }}
              </router-link>
              <router-link :to="{ name: 'my-favorites' }" @click.native="closeDropdown"
                           class="no-underline pv2 ph3 f5 pointer w-100">{{ $t("users.userMenu.myFavorites") }}
              </router-link>
              <a @click="setLanguage('es')" v-show="!isLocale('es')" class="pv2 ph3 f5 pointer w-100">{{ $t("footer.language.spanish") }}</a>
              <a @click="setLanguage('en')" v-show="!isLocale('en')" class="pv2 ph3 f5 pointer w-100">{{ $t("footer.language.english") }}</a>
              <a @click="setLanguage('pt')" v-show="!isLocale('pt')" class="pv2 ph3 f5 pointer w-100 ttu">{{ $t("footer.language.portuguese") }}</a>
              <router-link :to="{ name: 'help' }" @click.native="closeDropdown"
                           class="no-underline pv2 ph3 f5 pointer w-100">{{ $t("users.userMenu.help") }}
              </router-link>
              <!-- <a class="f5 no-underline pointer ph3 pv2" href="https://shop.beathey.com" target="_blank">
                <span>{{ $t('app.shop') }}</span>
              </a> -->
              <a @click="logoutButton" class="no-underline pv2 ph3 f5 pointer w-100">{{ $t("users.userMenu.logout") }}</a>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import UserInfo from '@/components/UserInfo.vue'
  import { mixin as onClickOutside } from 'vue-on-click-outside'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    name: 'landingNavBar',
    components: {
      UserInfo,
      FontAwesomeIcon,
      ClipLoader
    },
    data () {
      return {
        loginDropdown: false,
        dropdown: false,
        color: '#808080',
        size: '20px',
        CurrentPage: ''
      }
    },
    mixins: [onClickOutside],
    methods: {
      ...mapActions('translator', [
        'setLanguage'
      ]),
      ...mapActions('user', [
        'logout'
      ]),
      isLocale (lang) {
        return this.language === lang
      },
      login () {
        this.$auth0.loginWithRedirect()
      },
      signup () {
        this.$modal.show('signup-modal')
      },
      dropdownTrigger () {
        this.dropdown = !this.dropdown
      },
      closeDropdown () {
        this.dropdown = false
      },
      loginDropdownTrigger () {
        this.loginDropdown = !this.loginDropdown
      },
      closeLoginDropdown () {
        this.loginDropdown = false
      },
      goToHome () {
        this.$router.push({path: '/'})
      },
      logoutButton () {
        if (!this.preventLogout || (this.preventLogout && window.confirm(this.$t('app.leaveConfirmation')))) {
          this.closeDropdown()
          this.$auth0.logout()
          this.logout()
        }
      },
      checkUser (route) {
        if (!this.isLoggedIn) {
          this.$modal.show('login-modal')
          // } else if (!this.isProducer) {
          //  this.$toasted.show(this.$t('tracks.newTrack.notProducer'), {type: 'error'})
        } else if (!this.isSubscribed) {
          this.$modal.show('subscription-modal')
        } else {
          this.$router.push(route)
        }
      },
    },
    created () {
      this.CurrentPage = this.$route.name
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn',
        'isSubscribed',
        'isProducer',
        'user',
        'preventLogout'
      ]),
      ...mapGetters('translator', [
        'language'
      ]),
      loading () {
        return this.$loading.isLoading('user login') || this.$loading.isLoading('user checkUser')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    src: url('~@/assets/fonts/Humnst777-Blk-BT-Black-Italic.ttf') format('truetype');
  }

  @media screen and (max-width: 960px) {
    div.subs-container {
      display: block !important;
    }
    a.mobile-subs {
      display: block !important;
      font-size: 9px;
      font-weight: bold;
      margin-left: -0.8em;
    }
  }

  .customPosition{
    position: relative;
    top: 10px;
  }

  .btnLnb{
    height: 36px;
    width: 195px;
    border-radius: 35px 35px 35px 35px;
    outline: 0;
    border-width: 1px;
    border-color: #E6007E;
    background-color: #E6007E;
    color: #fff;
    outline-offset: 1px;
    text-decoration: none;
    overflow: hidden;
    text-align: center;
  }
  .btnLnb:hover{
    background-color: #fff !important;
    color: #E6007E !important ;
  }

  .btnLnbMobile{
    display: none;
    height: 36px;
    width: 105px;
    border-radius: 35px 35px 35px 35px;
    outline: 0;
    border-width: 1px;
    border-color: #E6007E;
    background-color: #E6007E;
    color: #fff;
    outline-offset: 1px;
    text-decoration: none;
    overflow: hidden;
    text-align: center;
  }
  .btnLnbMobile:hover{
    background-color: #fff !important;
    color: #E6007E !important ;
  }

  .mobile-subs {
    display: none;
  }
  .subs-container {
    margin: 0;
  }
  .header {
    height: $navigation-height;
  }

  #LNB, #LNB:active{
    color: $text-color;
    text-decoration: none;
    background-color: $secondary-color;
  }

  #HeaderLNB{
    position: fixed;
    z-index: 50;
    width: 100%;
  }

  .router-link-active, .link-primary:hover {
    .iconColor {
      color: #aaa
    }
    background-color: $background-color;
    color: $text-color ;
    transition: .3s;
  }

  .iconColor{
    color: $text-color;
  }

  .textColor{
    color: $text-color;
  }

  .router-link-active .white {
    color: white;
  }

  .isologo-container {
    height: $navigation-height;
    width: $navigation-height;
    max-width: $navigation-height;
    min-width: $navigation-height;
    max-height: $navigation-height;
    min-height: $navigation-height;
  }

  .logo-container {
    max-height: 100%;
    max-width: 160px;
  }

  .dropdown-content {
    right: 0;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    z-index: 10;
    background-color: $primary-color;
    color: $text-color;
  }

  .dropdown-content a {
    background-color: $primary-color;
    color: $text-color;
  }

  .dropdown-content a:hover {
    background-color: $background-color;
    color: $text-color !important;
    transition: .3s;
  }

  .dropdown-content button:hover {
    background-color: $background-color
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .mw-50 {
    max-width: 50%;
  }

  .min-w-25 {
    min-width: 25%;
  }

  @media screen and (min-width: 1125px) {
    .login {
      display: flex;
    }
    .login-dropdown {
      display: none;
    }
  }

  @media screen and (max-width: 1100px) {
    .btnLnbMobile{
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Landing/LandingNavBar.vue